import React from 'react'
import OfferPageDispatchContext from './offerPageDispatchContext'
import OfferPageStateContext from './offerPageStateContext'
import { OfferPageDispatchAction, OfferPageState } from './offerPageStateReducer'
import OfferPageStateSnapshotContext from './offerPageStateSnapshotContext'
import OfferPageStateTrackingProvider from './offerPageStateTrackingProvider'

interface Props {
  state: OfferPageState;
  stateSnapshotRef: React.MutableRefObject<OfferPageState>;
  dispatch: React.Dispatch<OfferPageDispatchAction>;
  children: React.ReactNode;
}

export function OfferPageStateProvider(props: Props) {
  return <OfferPageStateContext.Provider value={props.state}>
    <OfferPageStateSnapshotContext.Provider value={props.stateSnapshotRef}>
      <OfferPageDispatchContext.Provider value={props.dispatch}>
        <OfferPageStateTrackingProvider>
          {props.children}
        </OfferPageStateTrackingProvider>
      </OfferPageDispatchContext.Provider>
    </OfferPageStateSnapshotContext.Provider>
  </OfferPageStateContext.Provider>
}

export default OfferPageStateProvider
